import React from 'react';
import { Instagram, Facebook, Linkedin, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#111111] pt-20 pb-10 px-6 border-t border-gold/20" data-id="element-149">
      <div className="max-w-7xl mx-auto" data-id="element-150">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16 items-start" data-id="element-151">
          {/* Brand - Left */}
          <div data-id="element-152">
            <img src="https://cdn.magicpatterns.com/uploads/ef9QvYtTkNXd4Uer9fAQSB/JennyGong2.png" alt="Jenny Gong - Las Vegas Real Estate" className="h-16 brightness-0 invert mb-6" data-id="element-153" />
            <p className="text-white/50 font-light text-sm leading-relaxed mb-6" data-id="element-154">
              Curating the finest luxury real estate experiences in Las Vegas,
              Henderson, and surrounding exclusive communities.
            </p>
            <div className="flex gap-4" data-id="element-155">
              <a href="#" className="text-white/50 hover:text-gold transition-colors" data-id="element-156">
                <Instagram className="w-5 h-5" data-id="element-157" />
              </a>
              <a href="#" className="text-white/50 hover:text-gold transition-colors" data-id="element-158">
                <Facebook className="w-5 h-5" data-id="element-159" />
              </a>
              <a href="#" className="text-white/50 hover:text-gold transition-colors" data-id="element-160">
                <Linkedin className="w-5 h-5" data-id="element-161" />
              </a>
            </div>
          </div>

          {/* Center Nav Columns */}
          {/* Quick Links */}
          <div data-id="element-162">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-163">Navigation</h4>
            <ul className="space-y-4" data-id="element-164">
              <li data-id="element-165">
                <Link to="/" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-166">
                  Home
                </Link>
              </li>
              <li data-id="element-167">
                <a href="/#communities" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-168">
                  Communities
                </a>
              </li>
              <li data-id="element-169">
                <a href="/#listings" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-170">
                  Listings
                </a>
              </li>
              <li data-id="element-171">
                <a href="/#why-vegas" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-172">
                  Why Vegas
                </a>
              </li>
            </ul>
          </div>

          {/* Communities */}
          <div data-id="element-173">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-174">Top Areas</h4>
            <ul className="space-y-4" data-id="element-175">
              <li data-id="element-176">
                <Link to="/summerlin" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-177">
                  Summerlin
                </Link>
              </li>
              <li data-id="element-178">
                <Link to="/southern-highlands" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-179">
                  Southern Highlands
                </Link>
              </li>
              <li data-id="element-180">
                <Link to="/henderson" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-181">
                  Henderson
                </Link>
              </li>
              <li data-id="element-182">
                <Link to="/macdonald-highlands" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-183">
                  MacDonald Highlands
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-184">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-185">Contact</h4>
            <ul className="space-y-4 text-white/50 text-sm font-light" data-id="element-186">
              <li className="flex items-start gap-3" data-id="element-187">
                <span className="text-gold mt-1" data-id="element-188">📍</span>
                <span data-id="element-189">
                  8400 W Sahara Ave
                  <br data-id="element-190" />
                  Las Vegas, NV 89117
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-191">
                <span className="text-gold" data-id="element-192">📞</span>
                <a href="tel:+18583978218" className="hover:text-gold transition-colors" data-id="element-193">
                  (858) 397-8218
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-194">
                <span className="text-gold" data-id="element-195">
                  <Mail className="w-4 h-4" data-id="element-196" />
                </span>
                <a href="mailto:jenny@jennygong.com" className="hover:text-gold transition-colors" data-id="element-197">
                  jenny@jennygong.com
                </a>
              </li>
            </ul>
          </div>

          {/* Office Logo - Right */}
          <div className="flex items-start justify-center lg:justify-start" data-id="element-198">
            <div className="w-44 h-44 rounded-full bg-white flex items-center justify-center overflow-hidden shrink-0" data-id="element-199">
              <img src="https://cdn.magicpatterns.com/uploads/wHnsKvs7aJbugQwycoSyPx/LOVE_LAS_VEGAS_REALTY_Transparent_Logo.png" alt="Love Las Vegas Realty" className="w-[130%] h-[130%] object-contain scale-110 -translate-x-[2px]" data-id="element-200" />
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-201">
          <p className="text-white/30 text-xs uppercase tracking-widest" data-id="element-202">
            &copy; {new Date().getFullYear()} Jenny Gong Real Estate. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-white/30 text-xs uppercase tracking-widest" data-id="element-203">
            <Link to="/" className="hover:text-white transition-colors" data-id="element-204">
              Privacy Policy
            </Link>
            <Link to="/" className="hover:text-white transition-colors" data-id="element-205">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}